import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {AuthService} from './auth.service';
import {DropdownService} from './dropdown.service';
import {IItemInfo, ItemService} from './item.service';
import {Location} from '@angular/common';
import {TimeService} from '../pages/shared/services/time.service';
import {environment as localEnvironment} from '../../environments/environment';
import {environment as productionEnvironment} from '../../environments/environment.prod';

@Injectable()
export class BootService {
    itemId;
    env = localEnvironment || productionEnvironment;

    constructor(private http: HttpService,
                private auth: AuthService,
                private location: Location,
                private dropdownsService: DropdownService,
                private timeService: TimeService,
                private itemService: ItemService) {
    }

    private initializeApp(): void {
        const appName = (productionEnvironment || localEnvironment).appName;
        localStorage.setItem('app_name', appName);
    }

    public load(): Promise<any> {
        this.initializeApp();
        this.itemService.detectItemSelection();
        this.itemService.info.subscribe((data: IItemInfo) => {
            this.itemId = data.id;
        });
        return new Promise((resolve, reject) => {
            this.checkBrowserCompatibility(resolve, reject);
            const promise = new Promise((resolve, reject) => {
                if (localStorage.getItem('session')) {
                    resolve();
                } else {
                    const storedSingleUseToken = localStorage.getItem('singleUseToken');
                    window.addEventListener('message', (event) => {
                        if (event.origin === (this.env.baseUrl.usm.backEnd.slice(0, -1))) {
                            const parsedData = JSON.parse(event.data);
                            if (parsedData && 'singleUseToken' in parsedData && (storedSingleUseToken === 'null' || !storedSingleUseToken)) {
                                this.auth.singleUseToken.next(parsedData.singleUseToken);
                                localStorage.removeItem('singleUseToken');
                                resolve(event);
                            }
                            if (parsedData && 'isRedirectToCreateAccount' in parsedData) {
                                this.auth.isRedirectToCreateAccount.next(parsedData.isRedirectToCreateAccount);
                                resolve(event);
                            }
                        }
                    });
                    if (storedSingleUseToken) {
                        this.auth.singleUseToken.next(storedSingleUseToken);
                        localStorage.removeItem('singleUseToken');
                        resolve(event);
                    }
                }
            });
            promise.then(() => {
                this.auth.authenticate().then(() => {
                    const lang = this.location.path().split('/')[1] || 'prs';
                    localStorage.setItem('lang', lang);
                    this.auth.defaultUserLoggedInUrl = `/${lang}/`;
                    this.dropdownsService.validateAll().then(() => {
                        resolve(this.setSystemTime());
                    }, (error: any) => {
                        this.alertAndStopProcess(error);
                        localStorage.removeItem('session');
                    });
                }, (error) => {
                    console.error(error);
                    reject(error);
                });
            });

        }) as Promise<any>;


    }

    async func() {
        return new Promise((resolve, reject) => {
            window.addEventListener('message', (event) => {
                // return this.load();
            });
        });


        // await window.addEventListener('message', ()=> {
        //
        // });
        //         await this.load()
    }

    alertAndStopProcess(error) {
        if (error && error.status !== 401) {
            alert('خطا در عیار سازی سیستم. لطفاً صفحه را بازنشانی مجدد نمایید.\n' +
                '\n' +
                'از طرف تیم تخنیکی اداره تدارکات ملی.');
            console.error(error);
            window.stop();
        }
    }

    checkBrowserCompatibility(resolve, reject) {
        const ua = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
        let browser;
        if (navigator.userAgent.match(/Edge/i) || navigator.userAgent.match(/Trident.*rv[ :]*11\./i)) {
            browser = 'msie';
        } else {
            browser = ua[1].toLowerCase();
        }
        if (['chrome', 'safari', 'firefox', 'opera'].indexOf(browser) === -1) {
            const temp = confirm('کاربر گرامی!\n' +
                'متاسفانه این مرورگر برای بارگزاری این سیستم پشتیبانی نمیشود.\n' +
                'برای دانلود مرورگر پشتیبانی شده تایید نمایید.\n' +
                '\n' +
                ' - از طرف تیم تخنیکی اداره تدارکات ملی.');
            if (temp) {
                reject(true);
                (<any>window.location).href = 'https://www.google.com/chrome/';
            } else {
                reject(true);
                window.stop();
            }
        }
    }

    setSystemTime() {
        return new Promise((resolve, reject) => {
            this.http.get('api/time')
                .subscribe((time: { tzOffset: number, timestamp: number }) => {
                    localStorage.setItem('system⏲time', time.timestamp.toString());
                    localStorage.setItem('system🗺timezone', time.tzOffset.toString());
                    this.timeService.startTimer();
                    resolve(true);
                }, (error) => {
                    reject(false);
                    console.error(error);
                    window.stop();
                });
        });
    }

}
